// removed by extract-text-webpack-plugin
module.exports = {"icon":"onfido-sdk-ui-crossDevice-MobileConnected-icon","cancel":"onfido-sdk-ui-crossDevice-MobileConnected-cancel","help":"onfido-sdk-ui-crossDevice-MobileConnected-help","helpList":"onfido-sdk-ui-crossDevice-MobileConnected-helpList"};


//////////////////
// WEBPACK FOOTER
// ./components/crossDevice/MobileConnected/style.css
// module id = 394
// module chunks = 1